import DataStorage from '../_utils/DataStorage';
import Swiper from '../_libs/swiper.esm.browser.bundle'; // quiet

const MOBILE_WIDTH = 767;
const TRANSITION_DURATION = 1000;

export default class TeamGrid {


	// Constructor
	constructor(element) {

		var i;
		var l;


		////////////////////

		// Get Elements
		this.element = element
		this.categoryButtons = Array.prototype.slice.call(element.querySelectorAll('.section-team-grid--categories button'), 0);
		this.categoryButtonClick = this.categoryButtonClick.bind(this);
		for (i=0, l=this.categoryButtons.length; i<l; i++) {
			this.categoryButtons[i].addEventListener('click', this.categoryButtonClick);
		}

		this.categorySelect = element.querySelector('.section-team-grid--category select');
		this.categorySelectText = element.querySelector('.section-team-grid--category span');
		if (this.categorySelect) {
			this.categorySelect.addEventListener('change', this.categorySelectChange.bind(this));
		}

		this.sortContainer = element.querySelector('.section-team-grid--sort')
		this.sortSelect = element.querySelector('.section-team-grid--sort select');
		this.sortSelectText = element.querySelector('.section-team-grid--sort span');
		if (this.sortSelect) {
			this.sortSelect.addEventListener('change', this.sortSelectChange.bind(this));
		}

		this.buttonNext = element.querySelector('.paged-buttons--next');
		this.buttonPrev = element.querySelector('.paged-buttons--prev');
		this.swiperButtonClick = this.swiperButtonClick.bind(this);
		this.swiperChange = this.swiperChange.bind(this);
		this.buttonNext.addEventListener('click', this.swiperButtonClick);
		this.buttonPrev.addEventListener('click', this.swiperButtonClick);

		this.numberCurrent = element.querySelector('.paged-buttons--total strong');
		this.numberTotal = element.querySelector('.paged-buttons--total span');

		this.swiper = null;
		this.swiperContainer = element.querySelector('.swiper-container');
		this.swiperWrapper = element.querySelector('.swiper-wrapper');

		this.updateCards = this.updateCards.bind(this);
		this.viewAllContainer = element.querySelector('.section-team-grid--view-all');
		this.cardContainer = element.querySelector('.section-team-grid--items');
		this.cards = Array.prototype.slice.call(element.querySelectorAll('.card-team'), 0);

		this.hoverCardLinks = Array.prototype.slice.call(document.querySelectorAll('.with-hover-card'), 0)

		let hoverTimeout;


		window.addEventListener('load', () => {

			if (this.viewAllContainer) {
				this.hoverCardLinks.forEach((hoverCardLink) => {

					hoverCardLink.addEventListener('mouseenter', (e) => {

						let hoverCardLink = e.target.closest('a')
						this.viewAllContainerRect = this.viewAllContainer.getBoundingClientRect()
						let hoverCardLinkRect = hoverCardLink.getBoundingClientRect()

						let linkTop = hoverCardLinkRect.top - 100
						let linkLeft = hoverCardLinkRect.left - this.viewAllContainerRect.left

						hoverCardLink.classList.remove('align-top')
						hoverCardLink.classList.remove('align-bottom')
						if (linkTop < (this.viewAllContainerRect.height / 2)) {
							hoverCardLink.classList.add('align-top')
						} else {
							hoverCardLink.classList.add('align-bottom')
						}

						hoverCardLink.classList.remove('align-right')
						hoverCardLink.classList.remove('align-left')
						if (linkLeft < (this.viewAllContainerRect.width / 2)) {
							hoverCardLink.classList.add('align-right')
						} else {
							hoverCardLink.classList.add('align-left')
						}

						clearTimeout(hoverTimeout)
						hoverTimeout = setTimeout(() => {
							this.hoverCardLinks.forEach((inactiveLink) => {
								inactiveLink.classList.remove('active')
							})

							hoverCardLink.classList.add('active')
						}, 250)
					})

					hoverCardLink.addEventListener('mouseleave', (e) => {
						this.hoverCardLinks.forEach((inactiveLink) => {
							clearTimeout(hoverTimeout)
							inactiveLink.classList.remove('active')
						})
					})
				})
			}
		})



		////////////////////

		// Get Select Options

		this.categoryValues = {};
		if (this.categorySelect) {
			for (i=0, l=this.categorySelect.options.length; i<l; i++) {
				this.categoryValues[ this.categorySelect.options[i].value ] = this.categorySelect.options[i].text;
			}
		}

		this.sortValues = {};
		if (this.sortSelect) {
			for (i=0, l=this.sortSelect.options.length; i<l; i++) {
				this.sortValues[ this.sortSelect.options[i].value ] = this.sortSelect.options[i].text;
			}
		}

		////////////////////

		// Get Initial Values

		this.valCat = !this.viewAllContainer ? 'team_member' : 'all';
		this.valSort = 'role';
		this.valGoTo = null;

		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams) {
			const prevCat = urlParams.get('category');
			if (prevCat && this.categoryValues[prevCat] || prevCat === 'all') {
				this.valCat = prevCat;
				this.hasPrevCat = true
			}

			const prevGoTo = urlParams.get('goto');
			if (prevGoTo) {
				this.valGoTo = prevGoTo;
			}
		}

		const prevSort = DataStorage.getSessionItem('team-grid-sort');
		if (prevSort && this.sortValues[prevSort]) {
			this.valSort = prevSort;
		}

		////////////////////

		// Misc Vars

		this.isFirst = true;
		this.isMobile = false;
		this.timer = null;

		////////////////////

		// Initial Update

		this.updateFields();
	}


	// Public Methods
	resize() {

		// this.viewAllContainerRect = this.viewAllContainer.getBoundingClientRect()

		var layoutHasChanged = false;
		if (window.innerWidth <= MOBILE_WIDTH) {
			if (this.isMobile === false) {
				layoutHasChanged = true;
			}
			this.isMobile = true;
		} else {
			if (this.isMobile) {
				layoutHasChanged = true;
			}
			this.isMobile = false;
		}
		if (layoutHasChanged) {
			this.updateFields(true);
		}
	}


	// Update
	updateFields(forceUpdate) {

		clearTimeout(this.timer);

		if (this.valCat === 'all' && this.isMobile) {
			this.valCat = 'general-firm-management';
		}

		for (var i=0, l=this.categoryButtons.length; i<l; i++) {
			if (this.categoryButtons[i].getAttribute('data-key') === this.valCat) {
				this.categoryButtons[i].classList.add('active');
			} else {
				this.categoryButtons[i].classList.remove('active');
			}
		}

		if (this.categorySelect) {
			this.categorySelect.value = this.valCat;
			this.categorySelectText.innerHTML = this.categoryValues[this.valCat];
		}

		if (this.sortSelect) {
			this.sortSelect.value = this.valSort;
			this.sortSelectText.innerHTML = this.sortValues[this.valSort];
		}

		DataStorage.setSessionItem('team-grid-sort', this.valSort);

		if (forceUpdate || this.isFirst) {
			this.isFirst = false;
			this.updateCards();
		} else {
			if (this.viewAllContainer) {
				this.viewAllContainer.classList.add('fade-out');
			}

			if (this.cardContainer) {
				this.cardContainer.classList.add('fade-out');
			}

			if (this.swiperContainer) {
				this.swiperContainer.classList.add('fade-out');
			}

			this.timer = setTimeout(this.updateCards, TRANSITION_DURATION);
		}

    // Push a new history state with the updated URL
    let url = '/our-team/?category=' + this.valCat;
    history.pushState(null, null, url);

	}

	updateCards() {
		clearTimeout(this.timer);

		const cat = this.valCat;
		const container = (this.isMobile) ? this.swiperWrapper : this.cardContainer;

		this.cards.forEach(function(card){
			if (card.parentNode) {
				card.parentNode.removeChild(card);
			}
		});

		const catSortKey = 'data-team-sort-' + cat;

		const dataKey = (this.valSort === 'role') ? catSortKey : 'data-name';

		let filteredCards = this.cards.filter((card) => {
			const cats = card.getAttribute('data-categories').split('|');
			if (cat == 'all') {
				return true;
			}

			return (cats.indexOf(cat) > -1);
		})

		filteredCards.sort((a, b) => {

			let aVal = a.getAttribute(dataKey)
			let bVal = b.getAttribute(dataKey)

			if (dataKey != 'data-name') {
				aVal = parseInt(aVal);
				bVal = parseInt(bVal);
			}

			return aVal == bVal ? 0 : aVal > bVal ? 1 : -1;
		});

		if (this.swiper !== null) {
			this.swiper.destroy();
			this.swiper = null;
			this.swiperWrapper.innerHTML = '';
		}

		let gridHandler = this
		if (this.isMobile) {
			filteredCards.forEach(function(card){
				const cats = card.getAttribute('data-categories').split('|');

				if (cat === 'all') {
					if (gridHandler.viewAllContainer) {
						gridHandler.viewAllContainer.classList.remove('fade-out')
					}

					if (gridHandler.cardContainer) {
						gridHandler.cardContainer.classList.add('fade-out')
					}

					if (gridHandler.sortContainer) {
						gridHandler.sortContainer.classList.remove('enabled')
					}
				} else if (cats.indexOf(cat) > -1) {
					if (gridHandler.sortContainer) {
						gridHandler.sortContainer.classList.add('enabled')
					}
					if (gridHandler.viewAllContainer) {
						gridHandler.viewAllContainer.classList.add('fade-out')
					}

					if (gridHandler.cardContainer) {
						gridHandler.cardContainer.classList.remove('fade-out')
					}

					const slide = document.createElement('div');
					slide.className = 'swiper-slide';
					slide.appendChild(card);
					container.appendChild(slide);
				}
			});
			this.swiper = new Swiper(this.swiperContainer, {
				grabCursor: true,
				loop: false,
				on: {
					slideChange: this.swiperChange
				},
				slidesOffsetBefore: 25,
				slidesPerView: 'auto',
				slideToClickedSlide: false,
				spaceBetween: 5,
				threshold: 1
			});
			this.swiperChange();
		} else {
			filteredCards.forEach(function(card){
				const cats = card.getAttribute('data-categories').split('|');

				let cardLinkElem = card.querySelector('a')
				let cardLink = cardLinkElem.getAttribute('href')
				let queryIndex = cardLink.indexOf('?')
				let detailUrl = cardLink.substring(0, queryIndex === -1 ? cardLink.length : queryIndex)

				let backTo = card.dataset.backTo || 'about'

				detailUrl = `${detailUrl}?category=${cat}&backTo=${backTo}&sortBy=${DataStorage.getSessionItem('team-grid-sort')}`
				cardLinkElem.setAttribute('href', detailUrl)

				if (cat === 'all') {
					if (gridHandler.viewAllContainer) {
						gridHandler.viewAllContainer.classList.remove('fade-out')
					}

					if (gridHandler.cardContainer) {
						gridHandler.cardContainer.classList.add('fade-out')
					}

					if (gridHandler.sortContainer) {
						gridHandler.sortContainer.classList.remove('enabled')
					}

				} else if (cats.indexOf(cat) > -1) {
					if (gridHandler.sortContainer) {
						gridHandler.sortContainer.classList.add('enabled')
					}

					if (gridHandler.viewAllContainer) {
						gridHandler.viewAllContainer.classList.add('fade-out')
					}

					if (gridHandler.cardContainer) {
						gridHandler.cardContainer.classList.remove('fade-out')
					}

					container.appendChild(card);
				}
			});
		}

		window.dispatchEvent(new Event('resize'));
		// this.viewAllContainer.classList.remove('fade-out');
		// this.cardContainer.classList.remove('fade-out');
		this.swiperContainer.classList.remove('fade-out');

		let scrollTo;
		if (this.valGoTo) {
			scrollTo = document.getElementById('team-' + this.valGoTo);
		} else if (this.hasPrevCat) {
			scrollTo = this.element;
		}

		if (typeof scrollTo !== 'undefined') {
			const y = scrollTo.getBoundingClientRect().top + window.pageYOffset - 100;
			window.addEventListener('load', () => {
				window.scroll(0, y);
			})
		}

		this.valGoTo = null;
	}


	// Event Handlers
	categoryButtonClick(event) {
		event.preventDefault();
		document.activeElement.blur();
		this.valCat = event.currentTarget.getAttribute('data-key');
		this.updateFields();
	}
	categorySelectChange(event) {
		this.valCat = event.currentTarget.value;
		this.updateFields();
	}
	sortSelectChange(event) {
		this.valSort = event.currentTarget.value;
		this.updateFields();
	}
	swiperChange() {
		const currentPage = this.swiper.realIndex + 1;
		const totalPages = this.swiper.slides.length;

		this.buttonNext.classList.remove('is-disabled');
		this.buttonPrev.classList.remove('is-disabled');
		if (currentPage === totalPages) {
			this.buttonNext.classList.add('is-disabled');
		}
		if (currentPage === 1) {
			this.buttonPrev.classList.add('is-disabled');
		}

		this.numberCurrent.innerHTML = this.displayNumber(currentPage);
		this.numberTotal.innerHTML = this.displayNumber(totalPages);
	}
	swiperButtonClick(event) {
		event.preventDefault();
		if (this.swiper !== null) {
			if (event.currentTarget === this.buttonPrev) {
				this.swiper.slidePrev();
			} else {
				this.swiper.slideNext();
			}
		}
	}


	// Helpers
	displayNumber(number) {
		if (number < 10) {
			return '0' + number;
		}
		return number;
	}


}
